$(document).ready(function(){
    $(".js-up").on("click", function () {
        var body = $("html, body");
        body.stop().animate({scrollTop: 0}, 1500, 'swing');
    });
    $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        if (scroll > 900) {
            $(".js-up").addClass("visible");
        } else {
            $(".js-up").removeClass("visible");
        }
    });
});